import { fetchDataPromise, fetchFilePromise } from '../index';

export const getSummary = (resolve, reject, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['site'] + '/getsummary', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({})
  });

  fetchDataPromise(req, 'getSummary', resolve, reject);
}

export const saveOrganizationData = (resolve, reject, saveOrgData, mod, token) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['model'] + '/savemodelorganization?saveMod=' + mod;
  let req = new Request(requestURL, {
      method: 'POST',
      mode: 'cors',
      headers: {
          'Authorization' : token,
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(saveOrgData)
  });

  fetchDataPromise(req, 'savemodelorganization', resolve, reject)
}

export const exportSettingData = (resolve, reject, token) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['site'] + '/siteexport';
  let req = new Request(requestURL, {
      method: 'GET',
      mode: 'cors',
      headers: {
          'Authorization' : token
      }
  });

  fetchFilePromise(req, 'siteexport', resolve, reject)
}

export const importSettingData = (resolve, reject, token, formData) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['site'] + '/siteimport', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Authorization' : token,
      },
      body: formData
  });
      
  fetchDataPromise(req, 'siteimport', resolve, reject);
}

export const adjustImportData = (resolve, reject, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['site'] + '/adjustimportdata', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Authorization' : token,
      }
  });
      
  fetchDataPromise(req, 'adjustimportdata', resolve, reject);
}
export const getDNSSetting = (resolve, reject, token) => {
    let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['site'] + '/getdnssetting', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Authorization' : token,
            'Content-Type' : 'application/json'
        },
        body: JSON.stringify({})
    });

    fetchDataPromise(req, 'getSummary', resolve, reject);
}